import { masterConfig } from "../configs/generalConfig";
import { rebuiltMissTypeCount2026 } from "../configs/config2026";
import { rebuiltMissTypeCount8888 } from "../configs/config2026_2";

/**
 * The form a match is scouted with: the year's settings, or 2026 count mode's (8888),
 * with accuracy swapped for miss counts when miss-type is on.
 *
 * Pure, and computed from the mode as it is right now. Scout keeps a copy in state for
 * rendering, but that copy is set in an effect and lags one render behind a mode
 * switch - filling a record from it in that render used the previous mode's form.
 * Anything that decides which fields a record carries must use this instead.
 *
 * @param {number|string} configYear 8888 in 2026 count mode, otherwise the year
 * @param {number|string} settingsYear the season
 * @param {boolean} rebuiltMissType 2026 miss-type counting
 */
export function formSettingsFor(configYear, settingsYear, rebuiltMissType) {
    const next = clone(masterConfig[configYear].mainSettings);

    if (parseInt(settingsYear) === 2026 && rebuiltMissType) {
        next.auto = next.auto.filter(item => item.label !== "auto_accuracy");
        next.tele = next.tele.filter(item => item.label !== "tele_accuracy");

        const missType = parseInt(configYear) === 2026 ? rebuiltMissTypeCount2026 : rebuiltMissTypeCount8888;
        next.auto.push(clone(missType.auto[0]));
        next.tele.push(clone(missType.tele[0]));
    }
    return next;
}

/** structuredClone in the browser; the configs are plain data, so JSON where it is missing (Jest). */
function clone(value) {
    return typeof structuredClone === "function" ? structuredClone(value) : JSON.parse(JSON.stringify(value));
}
